<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>REGISTRAR MESSAGE</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Registrar Message</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02 py-4 ">
    <div class="container">
        <div class="row align-items-center mt-n1-9 pt-3 pt-md-5">
            <div class="col-lg-6 col-xl-7 mt-1-9 ">
                <div class="col-lg-12 order-2 order-lg-1 text-center">
                    <img src="assets/img/chancellor/image.jpg"/>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 mt-1-9">
                <div class="section-heading text-center text-md-start mb-0">
                    <span class="sub-title ">Registrar Message</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary text-center text-md-start">From the Desk of Registrar</h2>
                <p class="px-2" align="justify">Arni University is one of the top-rated private universities in Himachal Pradesh delivering quality
                    education in fields such as Engineering, Management, Computer Application, Sciences, Pharmacy and
                    Agriculture. Our Arni University family always advocates for innovation and excellence in the areas
                    of education, research and consultancy. Arni University is expanding under Honorable Chancellor’s
                    supervision and has done several academic collaborations with world class institutions. Under these
                    programs students get an exposure to work in various sectors and in multinational set-up. Arni
                    University has always aspired for hiring such young talents who can be part of our endeavors toward
                    the development of the nation.</p>
                <p class="px-2" align="justify">As the custodian of academic records and the steward of university policies and procedures related to
                    enrollment, registration and students records, our office is committed to supporting your academic
                    journey and ensuring the integrity and accuracy of your academic records.</p>




            </div>
            <div class="col-12 pt-3">

                <p class="px-2" align="justify">At Arni University, we strive to uphold the highest standards of academic excellence and integrity.
                    Our commitment to transparency, fairness, and accuracy ensures that each student’s academic journey
                    is guided by clear policies and procedures.</p>
                <p class="px-2" align="justify">As you explore the opportunities that await you at Arni University, I encourage you to reach out to
                    our office with any questions or concerns you may have. We are here to help you make informed
                    decisions and embark on a fulfilling academic experience.</p>
                <div class="section-heading text-center text-md-start mb-0 mt-3">
                    <span class="sub-title text-secondary">Dr.Trilochan Singh (Registrar)</span>
                </div>
            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>
